import "../styles/home.css";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

function Contact() {
  return (
    <>
      <Header />

      {/* ======================================================
         FULL-WIDTH PAGE SHELL
         ====================================================== */}
      <main className="home-shell">
        <div className="home-container">

          {/* ======================================================
             CONTACT SECTION
             ====================================================== */}
          <section className="section-block offset-left">
            <div className="section-card wide">
              <h2 className="section-title">contact prufyy</h2>

              <p>
                we keep support simple and human. depending on who you are and what
                you need help with, reach out to the appropriate team below.
              </p>

              <div className="card-grid three-col">

                {/* ================= FOUNDER SUPPORT ================= */}
                <div className="info-card">
                  <h3>founder support</h3>
                  <p>
                    if you are a founder using prufyy to create your startup profile,
                    upload pitch decks, manage claims, or add startup records, reach
                    out to us here.
                  </p>
                  <p>
                    this includes questions about your profile, visibility,
                    permissions, or how to best present your startup on prufyy.
                  </p>
                  <p>
                    <strong>email:</strong>{" "}
                    <a href="mailto:founder_support@prufyy.com">
                      founder_support@prufyy.com
                    </a>
                  </p>
                </div>

                {/* ================= EVALUATOR SUPPORT ================= */}
                <div className="info-card">
                  <h3>evaluator support</h3>
                  <p>
                    if you are an investor, angel, incubator, accelerator, or
                    evaluator reviewing startups on prufyy, contact us here.
                  </p>
                  <p>
                    this includes issues related to shared startups, reviews,
                    cohorts, analytics, or evaluator access.
                  </p>
                  <p>
                    <strong>email:</strong>{" "}
                    <a href="mailto:evaluator_support@prufyy.com">
                      evaluator_support@prufyy.com
                    </a>
                  </p>
                </div>

                {/* ================= GENERAL SUPPORT ================= */}
                <div className="info-card">
                  <h3>general support</h3>
                  <p>
                    for anything else — including account issues, pricing questions,
                    partnerships, or general inquiries — reach out to our general
                    support team.
                  </p>
                  <p>
                    we’ll make sure your message reaches the right people.
                  </p>
                  <p>
                    <strong>email:</strong>{" "}
                    <a href="mailto:support@prufyy.com">
                      support@prufyy.com
                    </a>
                  </p>
                </div>

              </div>
            </div>
          </section>

        </div>
      </main>

      <Footer />
    </>
  );
}

export default Contact;
